import { http } from "../http";
import { OrganizModal, AddPermissModal } from "@/facilities/model/user";
import { TABLEPAI } from "@/enums/pageEnum";

export const getList = async ({
  url,
  params,
}: {
  url: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params?: any;
}) => {
  return await http.get(url, { params });
};

export const putSuspend = async (ids?: number | string[]) => {
  return await http.put(`/api/organization/suspend`, { ids });
};

export const addOrganization = async (params: OrganizModal) => {
  return await http.post("/api/organization", params);
};

export const editOrganization = async (params: OrganizModal) => {
  return await http.put("/api/organization", params);
};

// organization type find permissions
export const findOrgPermiss = async (type?: string) => {
  return await http.get(TABLEPAI.ORGAPERMISS, {
    params: { type },
  });
};

export const findOrgAllPermiss = async () => {
  return await http.get("/api/organization/permissions");
};
// organization type add permissions
export const addOrgPermissions = async (
  url: string,
  params: AddPermissModal
) => {
  return await http.post(url, params);
};

// organization type remove permissions
export const removeOrgPermissions = async (
  url: string,
  params: AddPermissModal
) => {
  return await http.put(url, params);
};

export const findOrganRoles = async () => {
  return await http.get("/api/organization/roles");
};

// 机构的permissions
export const organPermiss = async () => {
  return await http.get("/api/organization/current/permissions");
};

export const organType = async () => {
  return await http.get("/api/organization/type/select");
};

export const putResume = async (ids?: number | string[]) => {
  return await http.put("/api/organization/resume", { ids });
};

export const getOrganInfo = async (id?: string) => {
  return await http.get(`/api/organization/${id}`);
};
